import {
  Box, ClickAwayListener, Grow, Paper, Popper,
} from '@mui/material'

const DesktopView = ({
  children,
  anchorRef,
  popperStatus,
  handleClose,
}) => (
  <Popper
    open={popperStatus}
    anchorEl={anchorRef?.current}
    role={undefined}
    transition
    disablePortal
    sx={styles.changeStatusPopper}
    placement='bottom-start'
  >
    {({
      TransitionProps,
      placement,
    }) => (
      <Grow
        {...TransitionProps}
        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
      >
        <Paper sx={styles.popperPaper} onClick={handleClose}>
          <ClickAwayListener onClickAway={handleClose}>
            <Box sx={styles.paperContainer}>
              {children}
            </Box>
          </ClickAwayListener>
        </Paper>
      </Grow>
    )}
  </Popper>
)

const styles = {
  moreActionsButton: {
    height: { xs: '30px', sm: '40px' },
    minWidth: { xs: '30px', sm: '40px' },
    borderRadius: '12px',
    border: 'solid 2px #e2e8ee',
    backgroundColor: '#f7f9fb',
    color: 'text.hint',
    overflow: 'hidden',
    padding: '0',
  },
  textStyle: {
    width: '100%',
    border: 0,
    backgroundColor: 'transparent',
    textTransform: 'capitalize',
    color: 'text.primary',
    fontSize: { xs: '14px', sm: '16px' },
  },

  changeStatusPopper: {
    minWidth: '200px',
    zIndex: '9',
  },
  popperPaper: {
    borderRadius: '12px',
  },
  paperContainer: {
    padding: '10px 0px',
  },

}

export default DesktopView
